import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarType } from 'app/constants/Enums';
import { GenericRoles } from 'app/helpers/constants';
import { SnackBarService } from 'app/services';
import { AppsService } from 'app/services/apps-service/apps.service';
import { first, mergeMap, Subject, takeUntil } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-apps-setup-dialog',
  templateUrl: './apps-setup-dialog.component.html',
  styleUrls: ['./apps-setup-dialog.component.scss']
})
export class AppsSetupDialogComponent implements OnInit {
  continueToAppSetUp:boolean=false;
  appRoles: any[] = [];
  isAppInternalOnly: boolean = false;
  loading:boolean=false;
  successMsg = '';
  successTxt ='';
  errorMsg='';
  errortxt='';
  private readonly onDestroy$ = new Subject<void>();
  
  constructor( public dialogRef: MatDialogRef<AppsSetupDialogComponent>,@Inject(MAT_DIALOG_DATA) public data,private readonly appsService:AppsService,private readonly _snackbarService:SnackBarService,private readonly _translateService: TranslateService) {
    this.appRoles = [
      { name: GenericRoles.appManagerRole, isSelected: true },
      { name: GenericRoles.userRole, isSelected: true },
    ];    
  }
  ngOnInit(): void {
      this.appRoles.forEach(role=>{ role.isDisabled = true;})
  }

  continueAppSetUp(){
    this.continueToAppSetUp=true
  }
  cancel() {
     this.dialogRef.close(false);
  }
  setUpApplication(){
    this.loading=true
    const selectedRoles=this.appRoles.map((role) => {
      if (role.isSelected) {
       return {name:role.name};
      }
    });
    const requestData={
      roleViewModelList: selectedRoles,
      internalOnly: this.isAppInternalOnly,
    }
    this._translateService
                .get('Application_Setup.success_message')
                .pipe(takeUntil(this.onDestroy$))
                .subscribe((value) => (this.successMsg = value));
              this._translateService
                .get('Application_Setup.success_header')
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(value => (this.successTxt = value));
                this._translateService
                .get('Application_Setup.error_message')
                .pipe(takeUntil(this.onDestroy$))
                .subscribe((value) => (this.errorMsg = value));
              this._translateService
                .get('Application_Setup.error_header')
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(value => (this.errortxt = value));
  
    this.postRoles(requestData);
  }

    postRoles(payload) {
      this.appsService
        .createApps(this.data.appId)
        .pipe(
          first(),
          mergeMap((res) => this.appsService.postRoles(payload,this.data.appId))
        )
        .subscribe({
          next:() => {
            this.appsService.getApps();
            this.loading=false;
            this.dialogRef.close(true);
            this._snackbarService.showSnackbar(
                        SnackbarType.success,
                        this.successTxt,
                        this.successMsg
                      );
          },
          error:() => {
            this.loading=false;
            this._snackbarService.showSnackbar(SnackbarType.error,this.errortxt,this.errorMsg);
          }
    });
    }
}
